import React from 'react';

const Speaker = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" 
            height="512" 
            viewBox="0 0 512 512" 
            width="512">
            <g>
                <path
                    fill="currentColor"
                    d="m345.995 31h-180.006c-24.814 0-45.001 20.187-45.001 45v360c0 24.813 20.187 45 45.001 45h180.006c24.814 0 45.001-20.187 45.001-45v-360c0-24.813-20.187-45-45.001-45zm15 405c0 8.271-6.729 15-15 15h-180.006c-8.272 0-15.001-6.729-15.001-15v-360c0-8.271 6.729-15 15.001-15h180.006c8.272 0 15 6.729 15 15z"/>
                
                <circle 
                    fill="currentColor"
                    cx="255.992" cy="166" r="15"/>
                
                <path 
                    fill="currentColor"
                    d="m255.992 91c-41.357 0-75.002 33.645-75.002 75s33.646 75 75.002 75 75.002-33.645 75.002-75-33.645-75-75.002-75zm0 120c-24.814 0-45.001-20.187-45.001-45s20.187-45 45.001-45 45.001 20.187 45.001 45-20.187 45-45.001 45z"/>
                
                <path 
                    fill="currentColor"
                    d="m92.518 217.374c-6.678-4.896-16.065-3.457-20.967 3.225-15.32 20.885-15.544 49.521-.03 70.775 4.884 6.69 14.265 8.157 20.961 3.272 6.692-4.884 8.157-14.268 3.273-20.96-7.761-10.631-7.63-24.959-.011-35.346 4.898-6.679 3.455-16.066-3.226-20.966z"/>
                
                <path 
                    fill="currentColor"
                    d="m38.819 188.956c-7.089-4.289-16.312-2.018-20.598 5.07-25.632 42.367-22.6 88.222-1.003 123.944 4.288 7.09 13.51 9.36 20.598 5.076 7.089-4.286 9.362-13.508 5.076-20.598-16.221-26.827-18.538-60.602.997-92.896 4.288-7.086 2.019-16.309-5.07-20.596z"/>
                
                <path 
                    fill="currentColor"
                    d="m419.466 217.374c-6.681 4.9-8.124 14.287-3.225 20.967 7.621 10.389 7.748 24.717-.011 35.346-4.884 6.692-3.419 16.076 3.273 20.96 6.688 4.882 16.073 3.421 20.961-3.272 15.523-21.268 15.28-49.902-.03-70.775-4.901-6.683-14.288-8.122-20.968-3.226z"/>
                
                <path 
                    fill="currentColor"
                    d="m494.763 194.026c-4.287-7.088-13.51-9.36-20.598-5.07-7.089 4.287-9.359 13.51-5.07 20.598 17.198 28.428 17.216 64.418-.003 92.896-4.285 7.09-2.013 16.312 5.076 20.598 7.095 4.287 16.313 2.009 20.598-5.076 22.959-37.977 22.999-85.926-.003-123.946z"/>
                
                <circle 
                    fill="currentColor"
                    cx="255.992" cy="346" r="15"/>

                <path 
                    fill="currentColor"
                    d="m255.992 271c-41.357 0-75.002 33.645-75.002 75s33.646 75 75.002 75 75.002-33.645 75.002-75-33.645-75-75.002-75zm0 120c-24.814 0-45.001-20.187-45.001-45s20.187-45 45.001-45 45.001 20.187 45.001 45-20.187 45-45.001 45z"/>
            </g>
        </svg>
    );
}

export default Speaker;
